import { AnalyticsStore, ContextStore, RouteStore } from 'bernie-core';
import { ILocalization } from 'bernie-l10n';

// Types
import { UIPageStore } from 'stores/ui-page-store';
import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

export interface ShareMenuState {
  isShareMenuOpen: boolean;
  hotelURL: string;
}

export interface ShareMenuProps {
  uiPage?: UIPageStore;
  analytics?: AnalyticsStore;
  routeStore?: RouteStore;
  l10n?: ILocalization;
  currentHotel?: CurrentHotelStore;
  context?: ContextStore;
}

export enum ShareEvents {
  OPEN_MENU = 'share-menu.open',
  CLOSE_MENU = 'share-menu.close',
  SHARE_FACEBOOK = 'share-facebook',
  SHARE_TWITTER = 'share-twitter',
  SHARE_COPY_LINK = 'share-copy-link',
  SHARE_EMAIL = 'share-email',
  SHARE_MOBILE_NATIVE = 'share-mobile-native'
}
